import Viewport from "@/store/modules/Viewport";

export type Contants = {
  bigWidth: number,
  smallWidth: number,
  ratio: {
    big: number,
    small: number
  },
  smallScale: {
    x: number,
    y: number
  },
  spriteScale: number,
  gap: number,
  offset: number,
  staggerGap: number,
}

export const colors = [
  0xC9F5DF,
  0xF5EFC9,
  0xCDC8F4,
  0xF5CEC9,
  0x6E67A0,
  0x387557,
]

export const canvasSize = {
  width: 0,
  height: 0,
  nbItemInViewport: 0,
  offsetIndex: 0,
  loopSize: 0,
  loopNbItem: 0,
  offsetVertical: 0,
}

export const getConstants = (): Contants => {
  const designWidth = Viewport.isDesktop ? 1600 : 375;
  const designRatio = (Viewport.windowWidth / designWidth);

  const screenRatio = Viewport.windowHeight / Viewport.windowWidth;

  // REDUCE IF ON DESKTOP IS NOT TALL ENOUGH
  // const bigRatio = screenRatio < 0.6 ? 0.667 : 1;
  const bigRatio = (screenRatio < (915/1600)) ? (screenRatio < (800/1600)) ? 0.667 : 0.833 : 1;
  const smallRatio = (screenRatio < (700/375)) ? (screenRatio < (620/375)) ? 0.667 : 0.833 : 1;
  // const smallRatio = 1;

  return Viewport.isDesktop ?
    {
      bigWidth: 480 * designRatio * bigRatio,
      smallWidth: 268 * designRatio * bigRatio,
      ratio: {
        big: 480 / 600,
        small: 268 / 533
      },
      smallScale: {
        x: 0.558,
        y: 0.888
      },
      spriteScale: 0.75,
      gap: 80 * designRatio * bigRatio,
      offset: 220 * designRatio * bigRatio,
      staggerGap: 0.04,
    } :
    {
      bigWidth: 280 * designRatio * smallRatio,
      smallWidth: 112 * designRatio * smallRatio,
      ratio: {
        big: 280 / 350,
        small: 112 / 223
      },
      smallScale: {
        x: 0.4,
        y: 0.637
      },
      spriteScale: 0.75,
      gap: 20 * designRatio * smallRatio,
      offset: 16 * designRatio * smallRatio,
      staggerGap: 0.05,
    }
}